import * as React from 'react';
import RootStore from './RootStore';

export const StoresContext = React.createContext<RootStore>(null as unknown as RootStore);
